/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { ConferenceTypeFromJSON, ConferenceTypeToJSON, } from './ConferenceType';
import { AssetFromJSON, AssetToJSON, } from './Asset';
import { BookingStatusFromJSON, BookingStatusToJSON, } from './BookingStatus';
import { MediaRegionFromJSON, MediaRegionToJSON, } from './MediaRegion';
/**
 * Check if a given object implements the ConferenceItem interface.
 */
export function instanceOfConferenceItem(value) {
    if (!('accountSid' in value) || value['accountSid'] === undefined)
        return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined)
        return false;
    if (!('conferenceId' in value) || value['conferenceId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('conferenceName' in value) || value['conferenceName'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    return true;
}
export function ConferenceItemFromJSON(json) {
    return ConferenceItemFromJSONTyped(json, false);
}
export function ConferenceItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountSid': json['accountSid'],
        'bookingId': json['bookingId'],
        'conferenceId': json['conferenceId'],
        'status': BookingStatusFromJSON(json['status']),
        'mohUrls': json['mohUrls'] == null ? undefined : json['mohUrls'],
        'conferenceName': json['conferenceName'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'conferenceType': json['conferenceType'] == null ? undefined : ConferenceTypeFromJSON(json['conferenceType']),
        'assignedHosts': json['assignedHosts'] == null ? undefined : json['assignedHosts'],
        'openingScript': json['openingScript'] == null ? undefined : json['openingScript'],
        'assets': json['assets'] == null ? undefined : (json['assets'].map(AssetFromJSON)),
        'expectedNumParticipants': json['expectedNumParticipants'] == null ? undefined : json['expectedNumParticipants'],
        'mediaRegion': json['mediaRegion'] == null ? undefined : MediaRegionFromJSON(json['mediaRegion']),
        'mMCWebcastURL': json['MMCWebcastURL'] == null ? undefined : json['MMCWebcastURL'],
        'statusCallbackURL': json['statusCallbackURL'] == null ? undefined : json['statusCallbackURL'],
        'meta': json['meta'] == null ? undefined : MetaDataFromJSON(json['meta']),
    };
}
export function ConferenceItemToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accountSid': value['accountSid'],
        'status': BookingStatusToJSON(value['status']),
        'mohUrls': value['mohUrls'],
        'conferenceName': value['conferenceName'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'conferenceType': ConferenceTypeToJSON(value['conferenceType']),
        'openingScript': value['openingScript'],
        'assets': value['assets'] == null ? undefined : (value['assets'].map(AssetToJSON)),
        'expectedNumParticipants': value['expectedNumParticipants'],
        'mediaRegion': MediaRegionToJSON(value['mediaRegion']),
        'MMCWebcastURL': value['mMCWebcastURL'],
        'statusCallbackURL': value['statusCallbackURL'],
        'meta': MetaDataToJSON(value['meta']),
    };
}
